import React from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';

const SectionCard = ({ title, subtitle, onClick, hasEditableFields }) => {
  const { t } = useTranslation();

  if (!hasEditableFields) {
    return null; // No mostrar card si no hay campos editables
  }

  return (
    <Card 
      sx={{ 
        height: '100%',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: 4,
          transform: 'translateY(-2px)'
        }
      }}
      onClick={onClick}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Box>
          <ArrowForwardIcon sx={{ color: 'text.secondary', ml: 2 }} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default SectionCard;
